import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        token: '',
    },
    getters: {},
    mutations: {
        setToken(state, token) {
            state.token = token;
        },
    },
    actions: {},
    modules: {
        user: {
            namespaced: true,
            state: {
                userId: undefined,
                username: undefined,
                avatar: undefined,
            },
            getters: {
                getUserId: state => state.userId,
                getUsername: state => state.username,
                getAvatar: state => state.avatar,
            },
            mutations: {
                setUserId: (state, userId) => {
                    state.userId = userId;
                },
                setUsername: (state, username) => {
                    state.username = username;
                },
                setAvatar: (state, avatar) => {
                    state.avatar = avatar;
                },
            },
            actions: {
                // Example action to update user information
                updateUserInfo({ commit }, userInfo) {
                    commit('setUserId', userInfo.userId);
                    commit('setUsername', userInfo.username);
                    commit('setAvatar', userInfo.avatar);
                },
            },
        },
    }
})